export const Checkmark = () => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g id="Icons">
      <g id="Group">
        <path
          id="Vector"
          d="M10.8036 29.9478C16.4941 29.9478 21.1072 25.3356 21.1072 19.6463C21.1072 13.9569 16.4941 9.34479 10.8036 9.34479C5.11308 9.34479 0.5 13.9569 0.5 19.6463C0.5 25.3356 5.11308 29.9478 10.8036 29.9478Z"
          fill="#018374"
        />
        <path
          id="Vector_2"
          d="M15.3493 25.403C21.0398 25.403 25.6529 20.7908 25.6529 15.1015C25.6529 9.41212 21.0398 4.79999 15.3493 4.79999C9.65874 4.79999 5.04565 9.41212 5.04565 15.1015C5.04565 20.7908 9.65874 25.403 15.3493 25.403Z"
          fill="white"
          stroke="#068C7C"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M10.3706 15.1015L13.9206 18.6508L20.9773 11.5955"
          stroke="#018374"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
)
